/**
 * How a Reel Option's market is named on screen — the feed's market name, else
 * the external id it was attached by, else `Not set`.
 *
 * Here rather than beside the detail tabs because `reel-stats.ts` has to count
 * *distinct* markets by the same key the rows are labelled with. Counting the
 * raw `externalMarketId` instead made the head disagree with the table under it:
 * two options the feed gave no market id but two different market names read as
 * one market above two visibly different labels.
 */
export interface ReelOptionMarketFields {
  marketName: string | null;
  externalMarketId: string | null;
}

export const reelOptionMarketLabel = (option: ReelOptionMarketFields): string => {
  const name = option.marketName?.trim();
  if (name) return name;
  const marketId = option.externalMarketId?.trim();
  if (marketId) return marketId;
  return 'Not set';
};
